/* ============================================================
   CLASE 33 — Animations
   Scroll-triggered reveals (one-time, ≤12px, ~500ms)
   ============================================================ */

(function () {
  'use strict';

  /* ── Intersection Observer (scroll-triggered reveals) ──────── */
  function initScrollReveal() {
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;

    const targets = document.querySelectorAll(
      '.c33-era, .c33-proceso-card, .c33-botella-card, .tl-era, .c33-hs__step, .c33-ed-card'
    );
    if (!targets.length) return;

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ── Boot ────────────────────────────────────────────────────── */
  function boot() {
    initScrollReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
